var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"main",style:({ paddingTop: _vm.isShowNav ? '60px' : '0px' })},[(_vm.isShowNav)?_c('nav',[_c('Navbar')],1):_vm._e(),_c('section',{class:[_vm.isShowNav && 'is_padding']},[_c('router-view')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }